var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"C-bookmark-button",class:{ 'C-bookmark-button--active': _vm.isBookmarked },attrs:{"size":"auto"},nativeOn:{"click":function($event){return _vm.toggleBookmark()}}},[_c('i',{staticClass:"fa-light fa-bookmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }